import { Spinner } from "@/web/components/primitives/spinner";
import { cn } from "@/web/lib/styling";

export function FullPageLoader({ color, className }: { color?: string; className?: string }) {
  return (
    <div className={cn("w-dwh flex h-dvh items-center justify-center", className)}>
      <Spinner size="large" className={color ? `text-${color}-500` : ""} />
    </div>
  );
}
